<template>
  <div class="purchaseOrder">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="委外发料详情"
        width="1600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="model"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div class="vm-separate">
          <el-form-item label="发料单号">
            <el-input v-model="model.billNo" placeholder="系统自动生成" disabled/>
          </el-form-item>
          <el-form-item label="采购单号">
            <el-input v-model="model.purchaseOrderNos" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="创建人">
            <el-input v-model="model.creatorName" placeholder="系统自动生成" disabled/>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-input v-model="model.createTime" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </div>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            发料明细
          </div>
          <el-table
              :data="purchaseList"
              border
              style="width: 100%">
            <el-table-column prop="materialNo" align="center" label="物料号" width="90"/>
            <el-table-column prop="mappingMaterialNo" align="center" label="旧物料号" width="90"/>
            <el-table-column prop="materialName" align="center" label="物料描述"/>
            <el-table-column prop="specification" align="center" label="规格型号" width="120"/>
            <el-table-column prop="replaceGroup" align="center" label="替代组" width="100"/>
            <el-table-column prop="replaceLevel" align="center" label="优先级" width="100"/>
            <el-table-column prop="location" align="center" label="存储地点" width="120">
              <template slot-scope="scope">
                <el-select v-model="scope.row.location" placeholder="请选择">
                  <el-option
                      v-for="item in scope.row.lgortDtos"
                      :key="item.lgort"
                      :label="item.lgobe"
                      :value="item.lgort"
                      @click.native="selectLocation(scope.row,item)"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="locationNo" align="center" label="库存仓位" width="80"/>
            <el-table-column prop="locationSumQty" align="center" label="工厂库存" width="80"/>
            <el-table-column prop="sumQty" align="center" label="发料数量" width="90">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sumQty" placeholder="请输入数量"/>
              </template>
            </el-table-column>
            <el-table-column prop="supplierSumQty" align="center" label="供应商库存" width="85"/>
            <el-table-column prop="billNo1" align="center" :label="billNo1" width="90"/>
            <el-table-column prop="billNo2" align="center" :label="billNo2" width="90"/>
            <el-table-column prop="billNo3" align="center" :label="billNo3" width="90"/>
            <el-table-column prop="billNo4" align="center" :label="billNo4" width="90"/>
            <el-table-column prop="billNo5" align="center" :label="billNo5" width="90"/>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <template>
          <el-button
              type="primary"
              :loading="saveLoading"
              @click="handleSave">保存</el-button>
        </template>
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import LoginUtil from "@/util/loginUtil";

  export default {
    name: "MergeOrderEdit",
    components: {},
    data() {
      return {
        uploadAuth: this.$auth(454),
        constant,
        constants,
        uploadLoading: false,
        userType: LoginUtil.getUserType(),
        dialogVisible: false,
        contentLoading: false,
        saveLoading: false,
        submitLoading: false,
        submitDisable: true,
        tableData: [],
        purchaseList: [],
        receiveStatus: "",
        billNo1: "",
        billNo2: "",
        billNo3: "",
        billNo4: "",
        billNo5: "",
        activeName: "first",
        files: [],
        model: {
          purchaseOrderNos: "",
          supplierNo: "",
          billNo: "",
          mergeMaterialDetails: [],
        },
        ruleValidate: {},
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row.length > 0) {
          let orderNoList = [];
          row.forEach((item) => {
            orderNoList.push(item.buyOrderNo);
          });
          this.model.purchaseOrderNos = orderNoList.join(",");
          this.model.supplierNo = row[0].gysCode;
          this.getData(orderNoList, this.model.supplierNo);
        }
      },
      getData(orderNoList, supplierNo) {
        this.contentLoading = true;
        this.$http.post("basic", `sapPurchaseOrders/createMergeOrder/${supplierNo}`, orderNoList).then((resp) => {
          console.log(resp.data);
          // this.model.mergeMaterialDetails = JSON.parse(JSON.stringify(resp.data));
          this.purchaseList = JSON.parse(JSON.stringify(resp.data));
          this.purchaseList.forEach(item=>{
            item.sumQty = 0.0;
          });
          if (resp.data[0].billNo1) {
            this.billNo1 = resp.data[0].billNo1;
          }
          if (resp.data[0].billNo2) {
            this.billNo2 = resp.data[0].billNo2;
          }
          if (resp.data[0].billNo3) {
            this.billNo3 = resp.data[0].billNo3;
          }
          if (resp.data[0].billNo4) {
            this.billNo4 = resp.data[0].billNo4;
          }
          if (resp.data[0].billNo5) {
            this.billNo5 = resp.data[0].billNo5;
          }
          this.purchaseList.splice(0, 1);
        }).finally(() => {
          this.contentLoading = false;
        });
      },
      handleSave() {
        this.model.mergeMaterialDetails = JSON.parse(JSON.stringify(this.purchaseList));
        this.model.mergeMaterialDetails.push({
          billNo1: this.billNo1,
          billNo2: this.billNo2,
          billNo3: this.billNo3,
          billNo4: this.billNo4,
          billNo5: this.billNo5,
        });
        this.saveLoading = true;
        this.$http
          .post("basic", "mergeMaterials", this.model)
          .then(() => {
            this.saveLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.saveLoading = false;
          });
      },
      selectLocation(row,item) {
        console.log(row);
        console.log(item);
        row.locationSumQty = item.labst;
      },

      handleSubmit() {
        this.submitLoading = true;
        this.$http
          .post("basic", "sapPurchaseOrders/responseDeliveryTime", this.purchase)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("提交成功");
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
::v-deep .el-dialog{
  top: 10% !important;
  left: 0 !important;
}
.purchaseOrder {
  .el-form-item__content {
    margin-left: 2% !important;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border: 1px solid #EBEEF5;
    border-bottom: none;
    border-left: none;
    margin-bottom: 15px;
  }

  table.gridtable tr td {
    padding: 8px;
    border-left: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
    border-left: 1px solid #EBEEF5;
  }
}

</style>
